import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CountWidgetSettings } from 'app/shared/models/count-widget-settings';
import { StatisticsService } from 'app/shared/services/statistics.service';
import { UserService } from 'app/shared/services/user.service';
import { Subscription } from 'rxjs';
import { OrganisationService } from 'app/shared/services/organisation.service';
import { LabelService } from '../label.service';
import { User } from 'app/shared/models/user';

@Component({
  selector: 'task-count-widget',
  styles: ['.countwidget{ display:inline !important; }'],
  // tslint:disable-next-line:max-line-length
  template: '<count-widget class="countwidget" title={{title}} count={{count}} label={{label}} extracount={{extracount}} extralabel={{extralabel}} detail={{detail}} color={{color}} route={{route}}></count-widget>',
})
export class TaskCountWidgetComponent implements OnInit, OnDestroy {

  count: number;
  title: string;
  label: string;
  extralabel: string;
  extracount: number;
  color: string;
  detail: string;
  route: string;
  prev: number[];
  users: number[] = [];

  _settings: CountWidgetSettings;

  selectedUsersChanged: Subscription;
  statisticsUpdated: Subscription;

  @Input() set settings(val: CountWidgetSettings) {
    if (val) {
      const settings = this._settings;
      this._settings = val || new CountWidgetSettings();
      this.setupWidget();
      this.setUserInfo();
      this.prev = [];
      if (this._settings) {
        this.updateCounts();
      }
    }
  }

  // added to suppress error messages
  @Input() id;
  @Input() subjectId;
  @Input() processTypeId;

  constructor(
    private statisticsService: StatisticsService,
    private organisationService: OrganisationService,
    private userService: UserService,
    private labelService: LabelService) {
    this.selectedUsersChanged = this.userService.onSelectedUsersChanged.subscribe((users: number[]) => {
      this.users = users;
      this.updateWidget(users);
    });
    this.statisticsUpdated = this.statisticsService.onStatisticsUpdated.subscribe((_) => { this.prev = []; });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.selectedUsersChanged) {
      this.selectedUsersChanged.unsubscribe();
    }
    if (this.statisticsUpdated) {
      this.statisticsUpdated.unsubscribe();
    }
  }

  updateWidget(users?) {
    if (this._settings) {
      this._settings.users = users;
      this.prev = users;
      this.setUserInfo();
      this.updateCounts();
    }
  }

  setupWidget() {
    const settings = this._settings;
    this.label = (settings && (settings.state.toLowerCase() !== 'all')) ? settings.state.toUpperCase() : 'TOTAL';
    this.color = (settings && settings.color) ? settings.color : 'rgb(244, 67, 54)';
    this.count = 0;

    if (settings && settings.showExtra) {
      const l = (settings.extraState) ? settings.extraState : '';
      this.extralabel = l + ((l) ? ' ' : '') + 'Tasks';
      this.extracount = 0;
    }
    else {
      this.extralabel = '';
    }
    this.detail = 'More information to go here...';
  }

  setUserInfo() {
    const settings = this._settings;
    const users = this.getUsers(settings);
    this.title = settings.title || this.labelService.getDefaultTitle(settings, users);
    this.route = this.getRoute(settings);
  }

  getRoute(settings: CountWidgetSettings) {
    let route: string = `/tasks/`;
    const users: number[] = [];
    const routeUsers: string[] = [];
    const state: string = settings.state.toLowerCase() || 'all';
    // path: 'tasks/user/:state/u/:user'
    if (settings.context && settings.context.length > 0) {
      const context = this.labelService.getContext(settings.context);
      context.forEach((i) => {
        switch (i) {
          case -1:
            route += 'users';
            break;
          case 0:
            route += 'all';
            break;  
          default:
            this.userService
              .getById(i)
              .subscribe((user: User) => {
                if (user) {
                  users.push(user.id);
                  routeUsers.push(user.uid);
                }
              });
            break;
        }
      });
      
      if (routeUsers.length > 0) {
        route += this.onlyCurrentUser(users)
          ? `my/${state}`
          : `users/${state}/u/${routeUsers.join(",")}`;

        if (settings.organisationId>0) {      
          return route+"/org/="+settings.organisationId;
        }
        else 
          return route
      }
      if (settings.organisationId>0) {      
        return `${route}/${state}`+"/org/"+settings.organisationId;
      }
      else 
      return `${route}/${state}`;
    }
    return route + 'all';
  }



  updateCounts() {
    const settings = this._settings;
    const context = this.labelService.getContext(settings.context);
    const users = this.getUsers(settings);

    this.count = (settings && settings.state) ?
      this.statisticsService.getTaskSnapshotStat(settings.state, settings.organisationId, users, context) : 0;

      if (settings && settings.showExtra) {
      this.extracount = this.statisticsService.getTaskSnapshotStat(settings.extraState, settings.organisationId, users, context);
    }

    // console.log('Updated task count widget counts:', settings, this.count, this.extracount);
  }

  onlyCurrentUser(users: number[]): boolean {
    if (users) {
      return ((users.length === 1) && (users[0] === this.userService.getCurrentUserId()));
    }
    else {
      return false;
    }
  }

  getUsers(settings) {
    return settings ? (this.users.length > 0) ? this.users : (settings.users || []) : this.users;
  }

}
